import httpClient from "./httpClient";

const prefix = "/configuration";

export function parseAppointmentMinutes(payload: any, fallback = 10): number {
  const candidates = [
    payload?.value?.minutes,
    payload?.minutes,
    typeof payload?.value === "number" ? payload.value : undefined,
  ];

  for (const raw of candidates) {
    const minutes = Number(raw);
    if (Number.isInteger(minutes) && minutes > 0) return minutes;
  }

  if (typeof payload?.value === "string") {
    try {
      const parsed = JSON.parse(payload.value);
      const minutes = Number(parsed?.minutes);
      if (Number.isInteger(minutes) && minutes > 0) return minutes;
    } catch {
      // ignore malformed json
    }
  }

  return fallback;
}

export async function findConfigurationByKey(key: string) {
  return (await httpClient.get(`${prefix}/key/${key}`)).data;
}

export async function getAppointmentTime(): Promise<number> {
  try {
    const data = (await httpClient.get(`${prefix}/appointment-time`)).data;
    return parseAppointmentMinutes(data, 0) || 10;
  } catch {
    try {
      const cfg = await findConfigurationByKey("Appointment");
      return parseAppointmentMinutes(cfg, 10);
    } catch {
      return 10;
    }
  }
}

export async function updateAppoinmentTime(minutes: number) {
  return (await httpClient.patch(`${prefix}/update-appoinment-time/${minutes}`))
    .data;
}

export async function updateConfig(configName: string, json: any) {
  return (await httpClient.patch(`${prefix}/update-config/${configName}`, json))
    .data;
}

export async function createAssistanceConfig(config: any) {
  return (await httpClient.post(`${prefix}/create-assistance-config`, config))
    .data;
}

export async function getDayZero() {
  return (await httpClient.get(`/day-zero-file`)).data;
}

export async function setDayZero(date: string) {
  return (await httpClient.patch(`/day-zero-file`, { date })).data;
}

export async function getDayDocumentsInit(): Promise<string | null> {
  const res = await httpClient.get(`${prefix}/day-documents-init`);
  return res.data ?? null;
}

export async function setDayDocumentsInit(date: string) {
  return (await httpClient.patch(`${prefix}/day-documents-init`, { date })).data;
}
